import { fontPresets, lineHeights, viewMap, defaultTheme, defaultLineHeight } from './config';
import { IFontPreset, IProps, TFontSize, TTheme } from './models';

export function prepareSet({
    fontPreset,
    fontSize,
    fontWeight,
    lineHeight,
    textTransform,
    view,
}: Pick<IProps, 'fontPreset' | 'view' | 'lineHeight' | 'fontWeight' | 'textTransform'> & {
    fontSize: TFontSize;
}): IFontPreset {
    if (fontPreset) return fontPresets[fontPreset];

    return {
        fontSize,
        ...(view && viewMap[view] && fontPresets[viewMap[view]]),
        ...(fontWeight && { fontWeight }),
        ...(lineHeight && { lineHeight }),
        ...(textTransform && { textTransform }),
    };
}

/**
 * Выбираем разрешенный line-height из списка разрешенных line-height.
 * @param lineHeight
 */
export function getLineHeight(lineHeight: number) {
    if (lineHeights.includes(lineHeight)) return lineHeight;
    if (lineHeight < lineHeights[0]) return lineHeights[0];
    if (lineHeight > lineHeights[lineHeights.length - 1]) {
        return lineHeights[lineHeights.length - 1];
    }

    return lineHeights.reduce((prev, curr) =>
        Math.abs(curr - lineHeight) < Math.abs(prev - lineHeight) ? curr : prev
    );
}

// TODO: пока приходится связывать группы тем и приводить только к имеющимся темам в самом text-v2
export const getTheme = (theme: TTheme) => {
    switch (theme) {
        case 'light':
        case 'white':
            return 'light';
        case 'black':
        case 'dark':
        case 'blue':
            return 'dark';
        default:
            return defaultTheme;
    }
};
/**
 * Высчитываем высоту строки
 * @param lines - количество строк
 * @param lineHeight - высота строки в px или строка по умолчанию в относительных единицах
 * @param fontSize - размер текста
 */
export function calcHeight(lines: number | undefined, lineHeight: number, fontSize: number) {
    if (!lines) return undefined;
    if (lineHeight === defaultLineHeight) {
        // webkit, chromium округляет значение в меньшую сторону, тогда как ff ничего не делает.
        // сделаем поведение одинаковым для всех браузеров
        return `${lines * Math.floor(lineHeight * fontSize)}px`;
    }

    return `${lines * lineHeight}px`;
}
